// Configuration dynamique selon l'environnement
const getApiBaseUrl = () => {
  // En production (Hostinger), utilise le chemin relatif
  if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    return '/api';
  }
  // En développement local, utilise localhost
  return 'http://localhost/argan-shop/api';
};

const API_BASE_URL = getApiBaseUrl();

// Fonction utilitaire pour les appels API
const apiRequest = async (endpoint, options = {}) => {
  try {
    const url = `${API_BASE_URL}/${endpoint}`;
    console.log(`🌐 Appel API: ${url}`, options.body ? JSON.parse(options.body) : '');
    
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    });

    // Vérifier le type de contenu
    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      const text = await response.text();
      console.error('❌ Réponse non-JSON:', text.substring(0, 200));
      throw new Error(`Le serveur a retourné une réponse non-JSON`);
    }

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || `Erreur HTTP: ${response.status}`);
    }

    return data;
  } catch (error) {
    console.error(`❌ Erreur API (${endpoint}):`, error);
    throw error;
  }
};

// Inscription - Adapté à votre table users
export const register = async (userData) => {
  console.log('📤 Envoi demande d\'inscription:', userData);
  
  const result = await apiRequest('register.php', {
    method: 'POST',
    body: JSON.stringify(userData),
  });

  console.log('✅ Réponse inscription:', result);
  
  if (result.success && result.user) {
    // Sauvegarder l'utilisateur dans le localStorage
    localStorage.setItem('user', JSON.stringify(result.user));
    
    // Créer un panier vide pour le nouvel utilisateur
    const newCart = {
      userId: result.user.id,
      items: [],
      total: 0
    };
    localStorage.setItem(`cart_${result.user.id}`, JSON.stringify(newCart));
    localStorage.setItem('userCart', JSON.stringify(newCart));
    
    console.log('💾 Utilisateur sauvegardé:', result.user);
  }

  return result;
};

// Connexion - Adapté à votre table users
export const login = async (credentials) => {
  console.log('📤 Envoi demande de connexion:', credentials);
  
  const result = await apiRequest('login.php', {
    method: 'POST',
    body: JSON.stringify(credentials),
  });

  console.log('✅ Réponse connexion:', result);
  
  if (result.success && result.user) {
    // Sauvegarder l'utilisateur dans le localStorage
    localStorage.setItem('user', JSON.stringify(result.user));
    
    // Charger le panier de l'utilisateur
    const userCart = localStorage.getItem(`cart_${result.user.id}`);
    if (userCart) {
      localStorage.setItem('userCart', userCart);
    } else {
      // Créer un nouveau panier vide
      const newCart = {
        userId: result.user.id,
        items: [],
        total: 0
      };
      localStorage.setItem(`cart_${result.user.id}`, JSON.stringify(newCart));
      localStorage.setItem('userCart', JSON.stringify(newCart));
    }
    
    console.log('💾 Utilisateur connecté:', result.user);
  }

  return result;
};

// Déconnexion - FONCTION AJOUTÉE
export const logout = async () => {
  const user = getCurrentUser();
  if (user) {
    console.log('🚪 Déconnexion de:', user.email);
    
    try {
      // Appeler l'API de déconnexion si elle existe
      await apiRequest('logout.php', {
        method: 'POST',
        credentials: 'include'
      });
    } catch (error) {
      console.log('ℹ️ API logout non disponible, déconnexion locale seulement');
    }
  }
  
  localStorage.removeItem('user');
  localStorage.removeItem('userCart');
};

// Récupérer l'utilisateur actuel - FONCTION AJOUTÉE
export const getCurrentUser = () => {
  try {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  } catch (error) {
    console.error('❌ Erreur parsing user:', error);
    return null;
  }
};

// Vérifier si l'utilisateur est connecté - FONCTION AJOUTÉE
export const isAuthenticated = () => {
  return !!getCurrentUser();
};

// Vérifier si l'utilisateur est admin - FONCTION AJOUTÉE
export const isAdmin = () => {
  const user = getCurrentUser();
  return user && user.role === 'admin';
};

// Rafraîchir les données utilisateur - FONCTION AJOUTÉE
export const refreshUserData = async () => {
  try {
    const user = getCurrentUser();
    if (!user) return null;

    const result = await apiRequest(`user.php?id=${user.id}`);
    if (result.success && result.user) {
      localStorage.setItem('user', JSON.stringify(result.user));
      return result.user;
    }
  } catch (error) {
    console.error('❌ Erreur rafraîchissement user:', error);
  }
  return null;
};